import React from "react";
import intersperse from "@ui-kit/utils/intersperse";

interface IProps {
  meta: React.ReactElement[];
}

const RadarlyCardSubtitle = ({ meta }: IProps) => (
  <>
    {intersperse(meta, () => (
      <>&nbsp;&nbsp;|&nbsp;&nbsp;</>
    ))}
  </>
);

export default RadarlyCardSubtitle;
